<template>
  <footer-item :clickHandler="onTermsAndConditionsClick" :text="goToTermsLabel"></footer-item>
</template>

<script>

import FooterItem from './FooterItem';
import {b2c} from "../../source/constants/scopes";

export default {
  computed: {
    goToTermsLabel() {
      return this.$gettext('Terms and conditions');
    },
    routeName() {
      return this.$route.name
    },
    routeScopes() {
      return this.$route.meta.scopes || []
    },
    isCandidateRoute() {
      return this.routeScopes.includes(b2c) || (this.routeName.includes('candidate') && this.$route.meta.isOpen) ||
        this.routeName === 'jobs' || this.routeName === 'job';
    },
  },
  methods: {
    onTermsAndConditionsClick() {
      this.$mam.trackTermsAndConditionsClicked();
      this.goToTerms();
    },
    goToTerms() {
      const prefix = this.$language.isChinese() ? '/cn' : '';
      if (this.isCandidateRoute) {
        window.open(`${prefix}/terms-and-conditions-candidate/`, '_blank');
        return
      }
      window.open(`${prefix}/terms-and-conditions/`, '_blank');
    }
  },
  components: {FooterItem}
};
</script>
